import React, { FC, useMemo } from 'react';
import SectionLoader from '../../../../../../common/components/loaders/SectionLoader';
import variantDataExtractor from '../../../../../../gqlCommon/service/variantDataExtractor';
import ModelList from './ModelList';
import { GetModelTrimLevel_trimLevelModels } from '../../../../../../trimLevels/graphql/queries/__generated__/GetModelTrimLevel';
import SpecificationsAndFeaturesContainer from '../../specificationsAndFeatures/SpecificationsAndFeaturesContainer';

interface IModelListContainerProps {
  models: GetModelTrimLevel_trimLevelModels[];
  selectedVariantId: string;
  changeVariant: (variantId: string) => void;
  isLoadingVariants: boolean;
}

const ModelListContainer: FC<IModelListContainerProps> = ({
  models,
  selectedVariantId,
  changeVariant,
  isLoadingVariants,
}) => {
  const selectedModelData = useMemo(
    () => variantDataExtractor.getModelByVariantId(models, selectedVariantId),
    [selectedVariantId, models],
  );

  if (isLoadingVariants && !models.length) {
    return <SectionLoader />;
  }

  return (
    <ModelList
      models={models}
      selectedVariantId={selectedVariantId}
      selectVariantId={changeVariant}
      detailsSlot={
        <SpecificationsAndFeaturesContainer
          oemCode={selectedModelData?.model.attributes?.oemcode}
          keyFeatures={selectedModelData?.carConfig?.car?.keyFeatures}
          specDescription={selectedModelData?.carConfig?.car?.attributes?.specDescription}
        />
      }
    />
  );
};

export default ModelListContainer;
